import React from 'react';
import './index.module.scss';

export default function Video({ video, videoType }) {
    return (
        <div
            style={videoType === 'vimeo' ? { paddingBottom: '56%' } : null}
            styleName="aspect-r"
        >
            {videoType === 'youtube' && (
                <iframe
                    style={{ width: '100%', height: '100%' }}
                    src={`https://www.youtube.com/embed/${video}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="youtube"
                />
            )}
            {videoType === 'vimeo' && (
                <iframe
                    src={`https://player.vimeo.com/video/${video}`}
                    style={{ width: '100%', height: '100%' }}
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    title="vimeo"
                />
            )}
        </div>
    );
}
